/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsMatchHistoryKdaDtoSchema } from "./matchHistoryKdaDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsMatchHistoryDtoSchema = z.object({
  id: z.string().nullish(),
  tournamentName: z.string().nullish(),
  tournamentId: z.string().nullish(),
  round: z.optional(z.int()),
  result: z.string().nullish(),
  opponentName: z.string().nullish(),
  myScore: z.int().nullish(),
  enemyScore: z.int().nullish(),
  date: z.optional(z.iso.datetime()),
  championName: z.string().nullish(),
  get kda() {
    return goodLuckCoreDTOsMatchHistoryKdaDtoSchema.optional();
  },
});
